import { T } from '@/ui/tokens';

export function ErrorBox({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div style={{
      margin: 20, padding: 16, borderRadius: T.radiusMd,
      background: 'rgba(255,90,110,0.08)', border: `1px solid rgba(255,90,110,0.30)`,
      color: T.danger, fontSize: 13, display: 'flex', alignItems: 'center', gap: 12,
    }}>
      <span style={{ flex: 1 }}>{message}</span>
      {onRetry && (
        <button onClick={onRetry} style={{
          padding: '6px 12px', borderRadius: 8, background: 'transparent',
          color: T.danger, border: `1px solid ${T.danger}`,
          fontSize: 12, fontWeight: 600, cursor: 'pointer',
        }}>Retry</button>
      )}
    </div>
  );
}
